const MapMarkerClusterIcon = '/icons/MapMarkerClusterIcon.svg';
const MapMarkerClusterYellowIcon = '/icons/MapMarkerClusterYellowIcon.svg';
export function renderClusterer({ yandexMaps, map, points, isLoad, }) {
    if (isLoad || !points?.length) {
        return;
    }
    map.geoObjects.removeAll();
    const clusterIconContentLayout = yandexMaps.templateLayoutFactory.createClass('<div style="margin-top: -3px;">{{properties.geoObjects.length}}</div>');
    const officeClusterer = defineClusterer('offices', yandexMaps, clusterIconContentLayout);
    if (points.length && points.every((_) => 'type' in _)) {
        const remoteWorkplaceClusterer = defineClusterer('workplaces', yandexMaps, clusterIconContentLayout);
        const remoteWorkplaceGeoObjects = defineGeoObjects(points.filter((_) => _.type === 'workplaces'), 'workplaces', yandexMaps);
        const officesGeoObjects = defineGeoObjects(points.filter((_) => _.type === 'offices'), 'offices', yandexMaps);
        officeClusterer.add(officesGeoObjects);
        remoteWorkplaceClusterer.add(remoteWorkplaceGeoObjects);
        map.geoObjects.add(remoteWorkplaceClusterer);
        map.geoObjects.add(officeClusterer);
    }
    else {
        const geoObjects = defineGeoObjects(points, 'offices', yandexMaps);
        officeClusterer.add(geoObjects);
        map.geoObjects.add(officeClusterer);
    }
    map.setBounds(yandexMaps.util.bounds.fromPoints(points.map((_) => _.coords))).then(() => {
        if (map.getZoom() > 10) {
            map.setZoom(10);
        }
    });
}
const defineClusterer = (type, yandexMaps, clusterIconContentLayout) => {
    return new yandexMaps.Clusterer({
        clusterIcons: [
            {
                href: type === 'offices' ? MapMarkerClusterIcon : MapMarkerClusterYellowIcon,
                size: [78, 84],
                offset: [-35, -50],
            },
        ],
        clusterIconContentLayout,
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
    });
};
const defineGeoObjects = (pointArr, type, yandexMaps) => {
    return pointArr.map(({ coords, content }) => new yandexMaps.Placemark(coords, {
        balloonContentHeader: content?.header,
        balloonContentBody: content?.body,
        balloonContentFooter: content?.footer,
        hintContent: content?.hint,
    }, {
        iconLayout: 'default#image',
        iconImageHref: type === 'offices' ? MapMarkerClusterIcon : MapMarkerClusterYellowIcon,
        iconImageSize: [78, 84],
        iconImageOffset: [-35, -50],
    }));
};
//# sourceMappingURL=renderClusterer.js.map